import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

import Constants from '../Constants';
import { useNavigate } from 'react-router-dom';

import wordmark from '../assets/menu-wordmark.png';

function EmailVerificationInvalidView() {
	const [message, setMessage] = useState('');
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState('');

	const navigate = useNavigate();

	async function handleResendVerification() {
		setMessage('');
		setSuccess(false);
		setError('');

		try {
			const email = localStorage.getItem(Constants.SIGNUP_USER_EMAIL);
			if(!email) {
				setError('No email address found. Please sign up again.');
				return;
			}

			const url = Constants.SERVER_URL + '/api/auth/resend_verification_email';
			const response = await axios.post(url, { email: email });

			if(response.status === 200) {
				setSuccess(true);
				setMessage('A new verification email has been sent to ' + email);
			} else {
				setError('Unexpected response from server.');
			}
		} catch(error) {
			if(error.response && error.response.data && error.response.data.message) {
				setError(error.response.data.message);
			} else {
				setError('Failed to connect to server.');
			}
		}
	}

	const handle_on_click = ()=>{
		navigate('/login');
	}

	function renderMainContent() {
		return(
			<div className="text-center email-verification-card">
					<p className='email-verification-text'>
						The email verification link you clicked is invalid or has expired.
					</p>

				{success && <Alert variant="success">{message}</Alert>}
				{error && <Alert variant="danger">{error}</Alert>}
			</div>
		);
	}

	return (
		<Container fluid className='auth-container'>
		<Row className='auth-row'>
			<Col lg={4} md={6} sm={10} xs={11}>
			<Card className='auth-card'>
				<Card.Body className='auth-card-body'>
				
					<Row>
					<img src={wordmark} className="signin-logo"/>
					<h3 className='auth-title'>Verification Email Sent</h3>
					</Row>
					<Row>
						{renderMainContent()}
					</Row>

					<Row>
						<Button variant="primary" onClick={handle_on_click}>Resend Verification Email</Button>
					</Row>

				</Card.Body>
			</Card>
			</Col>
		</Row>
		</Container>
	);

// 	return(
// 		<Container fluid className="min-vh-100 d-flex align-items-center justify-content-center">
// 			<Row className="w-100 justify-content-center">
// 				<Col lg={5} md={7} sm={10} xs={11}>
// 					<Card style={styles.card}>
// 						<Card.Body>
// 							{renderMainContent()}
// 						</Card.Body>
// 					</Card>
// 				</Col>
// 			</Row>
// 		</Container>
// 	);

}


export default EmailVerificationInvalidView;
